import { alpha } from '@mui/material';

export const tableRowTheme = {
    styleOverrides: {
        root: ({ theme }) => ({
            height: '100px',
            '&.MuiTableRow-hover:hover': {
                backgroundColor: alpha(theme.palette.primary.main, 0.04),
            },
        }),
    },
};
